<script lang="ts">
  import type { SeverityBand } from './types';

  let { band, severity }: { band: SeverityBand; severity?: number } = $props();
</script>

<span class={band}><span aria-hidden="true" class="marker"></span>{band}{severity === undefined ? '' : ` ${severity.toFixed(1)}`}</span>

<style>
  span { display: inline-flex; align-items: center; gap: .42rem; font-size: .76rem; font-weight: 780; letter-spacing: .025em; text-transform: uppercase; }
  .marker { width: .55rem; height: .55rem; border-radius: 50%; background: currentColor; }
  .low { color: #367250; }
  .medium { color: #8a5a00; }
  .high { color: #bc4c00; }
  .critical { color: #a61b1b; }
</style>
